import { createAction } from 'redux-actions';
export const SET_ORDER = 'SET_ORDER';
export const FILL_ORDER = 'FILL_ORDER';
export const ANALYZE_PURCHASEd_PRODUCTS = 'ANALYZE_PURCHASEd_PRODUCTS';
export const setOrder = createAction(SET_ORDER);
export const fillOrder = createAction(FILL_ORDER);
export const analyzePurchasedProducts = createAction(ANALYZE_PURCHASEd_PRODUCTS);
